module.exports = __webpack_public_path__ + "static/media/Behandeling.5d32af44.jpg";